/* eslint-disable */
// @ts-nocheck
import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'

import { Observable } from 'rxjs'
import { timeout } from 'rxjs/operators'

import { ApiOptions } from '@overtur-monorepo/keying-shared'

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  constructor(private httpClient: HttpClient) {}

  get<T extends any>(url: string, httpHeaders?: HttpHeaders, options: ApiOptions = {}): Observable<T> {
    return this.httpClient
      .get<T>(url, { headers: this.buildHttpHeaders(httpHeaders) })
      .pipe(timeout(this.getHttpTimeout(options)))
  }

  post<T extends any, R extends any>(
    url: string,
    payload: R,
    httpHeaders?: HttpHeaders,
    options: ApiOptions = {}
  ): Observable<T> {
    return this.httpClient
      .post<T>(url, payload, { headers: this.buildHttpHeaders(httpHeaders) })
      .pipe(timeout(this.getHttpTimeout(options)))
  }

  put<T extends any, R extends any>(
    url: string,
    payload: R,
    httpHeaders?: HttpHeaders,
    options: ApiOptions = {}
  ): Observable<T> {
    return this.httpClient
      .put<T>(url, payload, { headers: this.buildHttpHeaders(httpHeaders) })
      .pipe(timeout(this.getHttpTimeout(options)))
  }

  patch<T extends any, R extends any>(
    url: string,
    payload: R,
    httpHeaders?: HttpHeaders,
    options: ApiOptions = {}
  ): Observable<T> {
    return this.httpClient
      .patch<T>(url, payload, { headers: this.buildHttpHeaders(httpHeaders) })
      .pipe(timeout(this.getHttpTimeout(options)))
  }

  private buildHttpHeaders(httpHeaders: HttpHeaders): HttpHeaders {
    if (httpHeaders) {
      return httpHeaders
    }
    return new HttpHeaders().set('Content-Type', 'application/json').set('Accept', 'application/json')
  }

  private getHttpTimeout(options: ApiOptions): number {
    return options.timeout || 50000000
  }
}
